<template>
  <div class="users-container flex hover-border-primary-6-i" :class="{'multi-line':multiLine,'disabled':disabled}" @click="disabled?null:$emit('click')">
    <div class="flex-1 flex flex-wrap flex-top">
      <yxt-tag v-for="item in userList"
               :key="item.id"
               class="users-container--tag font-size-12"
               size="small"
               :closable="!disabled&&!readonly"
               type="info"
               @close="close(item)">
        <yxtbiz-user-name :name="item.fullName||item.fullname"/>
      </yxt-tag>
      <div v-if="userList.length===0" class="lh30 ph5 ml8 color-gray-6">{{ placeholder }}</div>
    </div>
    <div v-if="!disabled" class="mr8 flex flex-mid">
      <i slot="suffix" class="size14 color-gray-6 yxt-input__icon yxt-icon-more hand hover-primary-6"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UsersContainer',
  props: {
    users: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiLine: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    userList() {
      return this.users || [];
    }
  },
  methods: {
    close(tag) {
      let list = [...this.userList];
      const index = list.indexOf(tag);
      list.splice(index, 1);
      this.$emit('update:users', list);
    }
  }
};
</script>
